import react, { useEffect } from "react"
import "./admin.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSession, selectAdminToken, selectSessionId } from "./sessionSlice";

function Admin({children}){
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminToken = useSelector(selectAdminToken);
  const currentSessionId = useSelector(selectSessionId);

  // Initialize session from URL parameters for regular admins
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const sessionIdFromUrl = searchParams.get('sessionId');
    const organizationIdFromUrl = searchParams.get('organizationId');
    
    console.log('[Admin] URL params:', { sessionIdFromUrl, organizationIdFromUrl });
    console.log('[Admin] Current session:', { currentSessionId, adminToken });
    console.log('[Admin] location.search:', location.search);
    
    if (sessionIdFromUrl && organizationIdFromUrl) {
      // Regular admin coming from redirect - set session from URL params
      console.log('[Admin] Setting session from URL params:', { sessionIdFromUrl, organizationIdFromUrl });
      dispatch(setSession({ sessionId: sessionIdFromUrl, organizationId: organizationIdFromUrl }));
    } else if (location.pathname.includes('/admin') && !location.search) {
      // No URL params on admin page - log warning
      console.warn('[Admin] No URL params found. If this is a regular admin, they should have been redirected with session params.');
    }
  }, [location.search, location.pathname, dispatch]);

 const raw = location.pathname;
 const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
 const isRootAdmin = cleaned === "/admin";
 const isSuperAdmin = currentSessionId === 'admin';

 console.log('[Admin] Render - isSuperAdmin:', isSuperAdmin, 'sessionId:', currentSessionId);

      const redirectGameSession = () => {
        try {
          const stored =
            sessionStorage.getItem("userData") || localStorage.getItem("userData");
          if (!stored) return;
          const parsed = JSON.parse(stored);
          const gameId = parsed?.gameId;
          if (!gameId) return;
          window.location.href = `${process.env.REACT_APP_BASE_URL}/active-games/${gameId}`;
        } catch {
          /* ignore bad storage */
        }
      };

      return <div className="admin-background">
       <div className="header-admin">
        {/* {!isRootAdmin && (
          <div className="back-button-holder">
              <button
                className="back-button"
                onClick={() => navigate(-1)}
              >
              <i class="fa-solid fa-arrow-left"></i> Back
              </button>
          </div>
        )} */}

         <div class="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo"/>{isSuperAdmin && " SUPERADMIN"}
         </div>
         <div onClick={()=>{redirectGameSession()}}>Future India </div>
          
         </div>
       
         
         <div className="user">
            <img src="/admin/user.png"/>
         </div>
       </div>
       {children}
      </div>
}

export default Admin;
